import { Refresh } from "@mui/icons-material"
import { useAlert } from "components/Alerts/hooks"
import { alerts as alertsKeys } from 'keys'
import { surferHooks } from "components/Record"
import { useSelector } from "react-redux"
import { useCallback } from "react"

const useUpdateAssBtns = () => {
    const { setAlerts } = useAlert()
    const { isPlaying } = useSelector(state => state.wavesurfer)
    const { isCloseSttoper } = useSelector(state => state.markingWords)

    const onPause = surferHooks.useOnPause()

    const openInitializeConfirmation = useCallback(() => {
        onPause()
        setAlerts(alertsKeys.initializeAssessment, true)
    }, [isPlaying])

    const updateBrokenFileStatus = async () => {
        setAlerts(alertsKeys.selectStatusType, true)
    }

    const updateAssBtns = [
        {
            label: "איפוס",
            // icon: <Refresh />,
            action: openInitializeConfirmation,
            disabled: isCloseSttoper
        },
        {
            label: "החזר לביצוע חוזר",
            action: updateBrokenFileStatus,
            disabled: isCloseSttoper
        }
    ]

    return updateAssBtns
}

export default useUpdateAssBtns